
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.4844 16.7656C11.625 16.7656 11.7578 16.7396 11.8828 16.6875C12.0078 16.6302 12.1224 16.5443 12.2266 16.4297L17.8203 10.7188C18.0026 10.5365 18.0938 10.3177 18.0938 10.0625C18.0938 9.88542 18.0495 9.72656 17.9609 9.58594C17.8776 9.4401 17.7656 9.32552 17.625 9.24219C17.4844 9.15885 17.3255 9.11719 17.1484 9.11719C16.8932 9.11719 16.6667 9.21354 16.4688 9.40625L11.1406 14.875H11.8359L6.5 9.40625C6.30729 9.21354 6.08073 9.11719 5.82031 9.11719C5.64323 9.11719 5.48438 9.15885 5.34375 9.24219C5.20312 9.32552 5.09115 9.4401 5.00781 9.58594C4.92448 9.72656 4.88281 9.88542 4.88281 10.0625C4.88281 10.1927 4.90625 10.3125 4.95312 10.4219C5 10.526 5.06771 10.625 5.15625 10.7188L10.7422 16.4375C10.9661 16.6562 11.2135 16.7656 11.4844 16.7656Z","fill":"#1C1D20"}})])
          )
        }
      }
    